import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import { CSSTransition } from 'react-transition-group';

import './Navbar.css';

import { ReactComponent as BurgerIcon } from '../../icons/burger.svg';
import { ReactComponent as SignoutIcon } from '../../icons/signout.svg';
import { ReactComponent as HomeIcon } from '../../icons/home.svg';
import { ReactComponent as CaretIcon } from '../../icons/caret.svg';
import { ReactComponent as ChevronIcon } from '../../icons/chevron.svg';
import { ReactComponent as ArrowIcon } from '../../icons/arrow.svg';

var logo = '/icons/dercam-logo.png';

class NavItem extends React.Component {
	constructor(props){
		super(props)
		this.state = {
			open: false
		}
		this.toggleShow = this.toggleShow.bind(this);
		this.selectOnClick = this.selectOnClick.bind(this);
	}

	toggleShow() {
		this.setState({open: !this.state.open});
	}

	selectOnClick() {
		if(this.props.onClick){
			this.props.onClick();
			this.toggleShow();
		} else if(this.props.dropdown) {
			this.toggleShow();
		} else {
			return;
		}
	}

	render() {
        // Goal 3: Pass title prop for hover text (tooltips) and accessibility
		const iconButton = (
			<div 
                className="icon-button" 
                onClick={this.selectOnClick} 
                onBlur={this.toggleShow}
                title={this.props.title} 
                aria-label={this.props.title}
            >
				{this.props.icon}
			</div>
		);

		return (
		    <li className="nav-item">
                {this.props.to ? (
                    <Link to={this.props.to} className='react-link'>
                        {iconButton}
                    </Link>
                ) : (
                    iconButton
                )}

              {/* Goal 2: Pass down a function to allow children to close the dropdown */}
		      {this.state.open && React.Children.map(this.props.children, child => {
                  if (React.isValidElement(child)) {
                      return React.cloneElement(child, { closeDropdown: () => this.setState({open: false}) });
                  }
                  return child;
              })}
		    </li>
		);
	}
}

class DropdownItem extends React.Component {
    render () {
    	return (
            <div className="menu-item" onClick={this.props.onClick} role="button" tabIndex="0">
                <span className="icon-button">{this.props.leftIcon}</span>
                {this.props.children}
                <span className="icon-right">{this.props.rightIcon}</span>
            </div>
        );
     }
}

class DropdownSection extends React.Component {
    render () {
    	return (
            <div className="menu-item" onClick={this.props.onClick}>
                <span className="icon-button">{this.props.leftIcon}</span>
                {this.props.children}
                <span className="icon-right">{this.props.rightIcon}</span>
            </div>
        );
     }
}

class DropdownMenu extends React.Component {
	constructor(props){
		super(props)
		this.state = {
			activeMenu: 'default',
			menuHeight: null
		}
		this.dropdownRef = React.createRef(null);
		this.calcHeight = this.calcHeight.bind(this);
		this.setMenuState = this.setMenuState.bind(this);
	}

    componentDidMount() {
        if(this.dropdownRef.current && this.dropdownRef.current.firstChild) {
            this.setState({menuHeight: this.dropdownRef.current.firstChild.offsetHeight});
        }
    }

  	calcHeight(el) {
	    const height = el.offsetHeight;
	    this.setState({menuHeight: height});
	}

	setMenuState(activeMenu) {
	 	this.setState({activeMenu: activeMenu})
	}
  
  	render() {
  		return (
		    <div className="dropdown" style={{ height: this.state.menuHeight }} ref={this.dropdownRef}>

		      <CSSTransition
		        in={this.state.activeMenu === 'default'}
		        timeout={500}
		        classNames="menu-primary"
		        unmountOnExit
		        onEnter={this.calcHeight}>
		        <div className="menu">
                  {/* Goal 1 & 2: Added icons and wired up closeDropdown() to the onClick events */}
		          <DropdownItem
                    leftIcon="👤"
		            onClick={()=>{this.props.history.push('/u'); this.props.closeDropdown();}}>
		            My Account
		          </DropdownItem>
		          <DropdownItem
                    leftIcon="🖥️"
		            onClick={()=>{this.props.history.push('/u/dercam'); this.props.closeDropdown();}}>
		            DER-CAM UI
		          </DropdownItem>
		          <DropdownItem
                    leftIcon="🛠️"
		            onClick={()=>{this.props.history.push('/u/rdt'); this.props.closeDropdown();}}>
		            Resilient Design Tool
		          </DropdownItem>
		          <DropdownItem
                    leftIcon="⚡"
		            onClick={()=>{this.props.history.push('/u/api'); this.props.closeDropdown();}}>
		            DER-CAM API
		          </DropdownItem>
		          <DropdownItem
		            leftIcon={<SignoutIcon />}
		            onClick={()=>{this.props.userLogout(); this.props.closeDropdown();}}>
		            Logout
		          </DropdownItem>
		        </div>
		      </CSSTransition>

		      <CSSTransition
		        in={this.state.activeMenu === 'main'}
		        timeout={500}
		        classNames="menu-primary"
		        unmountOnExit
		        onEnter={this.calcHeight}>
		        <div className="menu">
		          <DropdownItem>My Profile</DropdownItem>
		          <DropdownItem
		            leftIcon={<HomeIcon />}
		            rightIcon={<ChevronIcon />}
		            onClick={()=>{this.setMenuState('settings')}}>
		            Settings
		          </DropdownItem>
		          <DropdownItem
		            leftIcon="🦧"
		            rightIcon={<ChevronIcon />}
		            onClick={()=>{this.setMenuState('animals')}}>
		            Animals
		          </DropdownItem>
		        </div>
		      </CSSTransition>

		      <CSSTransition
		        in={this.state.activeMenu === 'settings'}
		        timeout={500}
		        classNames="menu-secondary"
		        unmountOnExit
		        onEnter={this.calcHeight}>
		        <div className="menu">
		          <DropdownItem leftIcon={<ArrowIcon />} onClick={()=>{this.setMenuState('main')}}>
		            <h2>My Tutorial</h2>
		          </DropdownItem>
		          <DropdownItem leftIcon={<HomeIcon />}>HTML</DropdownItem>
		          <DropdownItem leftIcon={<HomeIcon />}>CSS</DropdownItem>
		          <DropdownItem leftIcon={<HomeIcon />}>JavaScript</DropdownItem>
		          <DropdownItem leftIcon={<HomeIcon />}>Awesome!</DropdownItem>
		        </div>
		      </CSSTransition>

		      <CSSTransition
		        in={this.state.activeMenu === 'animals'}
		        timeout={500}
		        classNames="menu-secondary"
		        unmountOnExit
		        onEnter={this.calcHeight}>
		        <div className="menu">
		          <DropdownItem leftIcon={<ArrowIcon />} onClick={()=>{this.setMenuState('main')}}>
		            <h2>Animals</h2>
		          </DropdownItem>
		          <DropdownItem leftIcon="🦘">Kangaroo</DropdownItem>
		          <DropdownItem leftIcon="🐸">Frog</DropdownItem>
		          <DropdownItem leftIcon="🦋">Horse?</DropdownItem>
		          <DropdownItem leftIcon="🦔">Hedgehog</DropdownItem>
		        </div>
		      </CSSTransition>
		    </div>
		)
  	}
}

class Navbar extends React.Component {

	renderNavButtonsIn() {
		return (
			<div className='nav-menu-button-container'>
                {/* Goal 3: Adding titles to the NavItems for clear hover tooltips */}
				<NavItem title="Go Back" icon={<ArrowIcon />} dropdown={false} onClick={()=>{this.props.history.go(-1)}} to={'/u'} />
				<NavItem title="Home" icon={<HomeIcon />} dropdown={false} onClick={null} to={'/u'} />
				<NavItem title="Logout" icon={<SignoutIcon />} dropdown={false} onClick={this.props.userLogout} />

				<NavItem title="Menu" icon={<BurgerIcon />} dropdown={true} onClick={null}>
					<DropdownMenu userLogout={this.props.userLogout} history={this.props.history} />
				</NavItem>
        	</div>
		)
	}

	renderNavButtonsOut() {
		return (
			<div className='nav-menu-button-container'>
				<NavItem title="Go Back" icon={<ArrowIcon />} dropdown={false} onClick={()=>{this.props.history.go(-1)}} to={'/u'} />
        	</div>
		)
	}

	selectNavButtons() {
		if(this.props.auth) {
			return(this.renderNavButtonsIn())
		} else {
			return(this.renderNavButtonsOut())
		}
	}

	render() {
		return (
			<div className="nav-container">
				<Link to="/u" className='nav-brand react-link' style={{ textDecoration: 'none', color: 'inherit' }}>
		        	<div className='nav-logo'>
		          		<img src={logo} alt="logo" />
			        </div>
			        <div className='nav-header-text'>
		          		<h1>DER-CAM<span className="nav-sub-head">IO</span></h1>
			        </div>
                </Link>
		        {this.selectNavButtons()}
		    </div>
		)
	}
}

export default withRouter(Navbar);